import React, { FC } from 'react';
import { IconProps } from '../types';
import { iconDefaultProps } from '../const';
import IconStyled from '../icon.styled';

const IconShare: FC<IconProps> = ({ $size, ...rest }) => (
  <IconStyled {...{ $size, ...rest }}>
    <svg width={$size} height={$size} viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0 12.4501C0 10.0127 0.555385 8.06522 1.65038 6.65761C2.97269 4.95821 5.06115 4.04136 7.86423 3.92799V0L16 6.84783L7.86423 13.6957V9.79049C6.16231 9.83576 4.87731 10.0789 3.85385 10.5453C2.74808 11.0493 1.94615 11.8026 1.08154 12.7784L0 14V12.4501Z"
        fill="white"
      />
    </svg>
  </IconStyled>
);

IconShare.defaultProps = iconDefaultProps;
IconShare.displayName = 'IconShare';

export default IconShare;
